import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { WhatYouControlComponent } from '../../example-workday/previews/what-you-control.component';

@Component({
  selector: 'app-what-you-control-dialog',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule, WhatYouControlComponent],
  template: `
    <h2 mat-dialog-title>What SuperSee collects — and what you control</h2>
    <mat-dialog-content>
      <app-what-you-control [compact]="true" [trackShown]="true"></app-what-you-control>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button mat-dialog-close type="button">Close</button>
    </mat-dialog-actions>
  `
})
export class WhatYouControlDialogComponent {}
